import moment from "moment";
import { LoadState } from "../../constants/enums";
import {
  IServiceOrder,
  IServiceOrderItem,
  IServiceOrderState,
} from "./service-order.types";
import { defaultServiceRequesitionItem } from "../service-request/service-request.state";

export const defaultServiceOrderItem: IServiceOrderItem = {
  ...defaultServiceRequesitionItem,
  service_requesition_uuid: "",
  service_requesition_name: "",
  project_uuid: "",
  project_name: "",

  sub_total: 0,
  gst: 0,
  gst_amount: 0,
  total: 0,
};

export const defaultServiceOrder: IServiceOrder = {
  service_order_uuid: null,
  service_order_type: "",
  service_order_no: "",
  service_order_date: moment().format("YYYY-MM-DD"),
  priority: null,

  service_requesition_uuid: "",
  service_requesition_name: "",
  service_requisition_no: "",
  project_uuid: "",
  project_name: "",
  project_manager_uuid: "",
  project_manager_name: "",

  billing_company_uuid: null,
  billing_company_name: null,
  billing_company_branch_uuid: null,
  billing_company_branch_name: null,
  billing_company_branch_address_state: null,

  vendor_uuid: "",
  vendor_name: "",
  vendor_registration_type: "",
  vendor_gstin: "",
  vendor_address_line1: null,
  vendor_address_line2: null,
  vendor_address_city: null,
  vendor_address_state: null,
  vendor_address_pincode: null,
  vendor_address_country: null,
  delivery_address_name: null,
  delivery_address_line1: null,
  delivery_address_line2: null,
  delivery_address_city: null,
  delivery_address_state: null,
  delivery_address_pincode: null,
  delivery_address_country: null,

  attachments: [],
  service_line_items: [],

  sub_total: 0,
  discount: 0,
  discount_amount: 0,
  gst: 0,
  gst_amount: 0,
  tds: 0,
  tds_amount: 0,
  total: 0,
  is_round_off: 0,

  term_and_conditions: null,
  payment_terms: null,
  addtional_clauses_or_conditions: null,
  remark: null,
  status: "DRAFT",
};

export const defaultServiceOrderState: IServiceOrderState = {
  service_order_list: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  },
  single_service_order: {
    data: defaultServiceOrder,
    loading: LoadState.NotLoaded,
    error: null,
  },
  service_order_approval_List: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
